<template>
  <Modal
    title="批量编辑质检类型比例"
    class="batch-update-checkType"
    v-model="modalVisible"
    width="650px"
  >
    <Form ref="batchCheckTypeForm" :model="fromData" :rules="fromRule" :label-width="140">
      <div>
        <Form-item prop="checkType" style="display: inline-block;">
          <div slot="label">
            <Checkbox v-model="fromData.updateCheck" class="label-check-box">
              <span>质检类型</span>
            </Checkbox>
          </div>
          <RadioGroup v-model="fromData.checkType">
            <Radio label="0" :disabled="!fromData.updateCheck">免检</Radio>
            <Radio label="2" :disabled="!fromData.updateCheck">全检</Radio>
            <Radio label="1" :disabled="!fromData.updateCheck">抽检</Radio>
          </RadioGroup>
        </Form-item>
        <Form-item label="质检比例(%)" prop="checkRate" style="display: inline-block;">
          <Input
            :disabled="![1, '1'].includes(fromData.checkType) || !fromData.updateCheck"
            v-model.trim="fromData.checkRate"
            placeholder="请输入质检比例"
          />
        </Form-item>
      </div>
      <Form-item prop="minCheckNum" >
        <div slot="label">
          <Checkbox v-model="fromData.updateMinCheckNum" class="label-check-box">
            <span>应检最少数量</span>
          </Checkbox>
        </div>
        <Input
          :disabled="!fromData.updateMinCheckNum"
          v-model.trim="fromData.minCheckNum"
          placeholder="请输入应检最少数量"
          style="width: 200px;"
        />
      </Form-item>
      <Form-item prop="newSupplierCheck">
        <div slot="label">
          <Checkbox v-model="fromData.updateNewSupplierCheck" class="label-check-box">新供应商强制全检</Checkbox>
        </div>
        <Checkbox class="ml5" v-model="fromData.newSupplierCheck" :disabled="!fromData.updateNewSupplierCheck" />
      </Form-item>
      <Spin v-if="loading" fix></Spin>
    </Form>
    <div slot="footer">
      <Button @click="modalVisible = false">取 消</Button>
      <Button @click="confirm" type="primary" :loading="loading">确 认</Button>
    </div>
  </Modal>
</template>
<script>
import api from '@/api/api';

export default {
  name: 'batchRemarkModal',
  components: {},
  props: {
    moduleVisible: { type: Boolean, default: false },
    spuTotal: { type: Number, default: null },
    moduleData: {
      type: Object,
      default: () => {
        return {
          row: []
        }
      }
    },
    selectAll: {
      type: Boolean,
      default: false
    },
    getListQuery: {
      type: Function,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      modalVisible: false,
      loading: false,
      fromData: {
        checkType: '0',
        checkRate: '0',
        minCheckNum: null,
        updateCheck: false,
        updateMinCheckNum: false,
        newSupplierCheck: false,
        updateNewSupplierCheck: false,
      },
      fromRule: {
        checkRate: [
          { validator: this.validateCheckRate, min: 1, max: 99, point: 0, msg: `请输入质检比例`, trigger: 'change' },
          { validator: this.validateCheckRate, min: 1, max: 99, point: 0, msg: `请输入质检比例`, trigger: 'blur' }
        ],
        minCheckNum: [
          { validator: this.validateMinCheckNum, min: 1, point: 0, msg: `请输入应检最少数量`, trigger: 'change' },
          { validator: this.validateMinCheckNum, min: 1, point: 0, msg: `请输入应检最少数量`, trigger: 'blur' }
        ]
      },
      oldFromData: {}
    }
  },
  watch: {
    moduleVisible: {
      deep: true,
      immediate: true,
      handler (val) {
        this.modalVisible = val;
        this.$nextTick(() => {
          val && this.initData();
        })
      }
    },
    modalVisible: {
      deep: true,
      handler (val) {
        this.$emit('update:moduleVisible', val);
        this.$nextTick(() => {
          !val && this.closeModal();
        })
      }
    },
    // 类型改变时
    'fromData.checkType': {
      deep: true,
      handler (val) {
        if ([0, '0'].includes(val)) {
          this.$set(this.fromData, 'checkRate', '0');
          this.$set(this.fromData, 'minCheckNum', null);
          this.$set(this.fromData, 'updateMinCheckNum', false);
          return;
        }
        if ([1, '1'].includes(val)) {
          const rate = Number(this.fromData.checkRate);
          const lastRate = this.$common.isEmpty(rate) ? '1' : rate > 1 && rate < 100 ? Math.floor(rate).toString() : '1';
          this.$set(this.fromData, 'checkRate', lastRate);
          return;
        }
        if ([2, '2'].includes(val)) {
          this.$set(this.fromData, 'checkRate', '100');
        }
      }
    }
  },
  computed: {},
  created () {},
  mounted () {},
  methods: {
    // 初始化数据
    initData () {
      this.oldFromData = this.$common.copy(this.fromData);
    },
    // 确认保存
    confirm () {
      if (this.loading) return;
      this.$refs.batchCheckTypeForm.validate((valid) => {
        if (!valid) return;
        if (!this.fromData.updateCheck && !this.fromData.updateMinCheckNum && !this.fromData.updateNewSupplierCheck) {
          this.$Message.error("质检类型、应检最少数量、新供应商强制全检最少选择一个修改");
          return;
        }
        let params = {};
        let queryParams = {};
        const updateItem = {
          updateCheck: this.fromData.updateCheck,
          updateMinCheckNum: this.fromData.updateMinCheckNum,
          updateNewSupplierCheck: this.fromData.updateNewSupplierCheck,
        };
        if (this.fromData.updateCheck) {
          params.checkRate = this.fromData.checkRate;
          params.checkType = this.fromData.checkType;
        }
        if (this.fromData.updateMinCheckNum) {
          params.minCheckNum = this.fromData.minCheckNum;
        }
        if (this.fromData.updateNewSupplierCheck) {
          params.newSupplierCheck = this.fromData.newSupplierCheck ? 1 : 0;
        }
        if (this.selectAll === true) {
          queryParams = {
            ...(this.getListQuery()),
            ...params,
            ...updateItem,
            selectAll: 1
          }
        } else {
          queryParams = {
            ...params,
            ...updateItem,
            selectAll: 0,
            setCheckQOList: this.moduleData.row.map(m => {
              return {
                productId: m.productId,
                ...params,
              }
            })
          }
        }
        this.$Modal.confirm({
          title: '确认是否批量修改数据？',
          content: `这次修改数据：${this.selectAll === true ? this.spuTotal : queryParams.setCheckQOList.length} 条`,
          okText: '确认',
          cancelText: '取消',
          onOk: () => {
            this.loading = true;
            this.axios.post(api.uptate_checkType, queryParams).then((res) => {
              this.loading = false;
              if (res && res.data && res.data.code === 0) {
                this.$Message.success("操作成功");
                this.modalVisible = false;
                this.$emit('updateList');
              }
            }).catch(() => {
              this.loading = false;
            })
            // this.$Modal.remove();
          }
        })
      })
    },
    // 关闭弹窗时，重置数据
    closeModal () {
      this.fromData = this.$common.copy(this.oldFromData);
      this.$nextTick(() => {
        this.$refs.batchCheckTypeForm.resetFields();
      })
    },
    // 验证质检比例
    validateCheckRate (rule, value, callback) {
      if (![1, '1'].includes(this.fromData.checkType)) {
        return callback();
      }
      this.$nextTick(() => {
        let newVal = this.fromData.checkRate;
        if (this.$common.isEmpty(newVal, true)) {
          return callback(new Error('请输入质检比例'));
        }
        this.$common.validatorMaxNumber(rule, newVal, callback);
      })
    },
    // 验证应检最少数量
    validateMinCheckNum (rule, value, callback) {
      this.$nextTick(() => {
        let newVal = this.fromData.minCheckNum;
        this.$common.validatorMaxNumber(rule, newVal, callback);
      })
    },
  }
};
</script>
<style lang="less" scoped>
.batch-update-checkType{
  position: relative;
}
.label-check-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
